import {useCallback} from 'react';
import {useNavigate} from 'react-router-dom';

export const useDialogNavigation = (path = '..') => {
    const navigate = useNavigate();
    return useCallback(() => navigate(path), [navigate, path]);
};